<template>
  <table class="table table-bordered med__table">
    <thead>
      <tr class="header">
        <th class="med___type">{{ $t('smartChart.typeOfMedicine') }}</th>
        <th>{{ $t('smartChart.totalDose') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(medItem, j) in medicine"
        :key="`${medItem.key}_${medItem.value}_${j}`"
        class="med__item"
      >
        <td>
          {{ $t(`smartChart.${medItem.key}Label`) }}
        </td>
        <td>{{ medItem.value }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'MedicineWidget',
  props: {
    medicine: Array,
  },
};
</script>
<style lang="scss" scoped>
.med__table {
  .header {
    th:first-child {
      min-width: 160px;
    }
  }
  tr.med__item {
    td {
      vertical-align: middle;
    }
  }
}
</style>
